<cc-icon
    #icon
    [icon]="'cog-outline'"
    [size]="'medium'"
    title="User Settings"
    (iconClicked)="showForm = !showForm"
>
</cc-icon>

@if (showForm) {
    <ddv-user-preferences-form
        [ccModal]="modalOptions"
        (dismissed)="showForm = false"
        [clientCode]="clientCode"
        [isMultiClient]="isMultiClient"
        [user]="user"
        [userEntitlements]="userEntitlements"
        [userPreferences]="userPreferences"
        [funds]="funds"
        [clients]="clients"
        [fuzzyDates]="fuzzyDates"
        (userPreferencesChange)="userPreferencesChange.emit($event)"
    >
    </ddv-user-preferences-form>
}
